export default "__VITE_ASSET__73f7e302__"